import React from 'react';

export const CallLogsIcon = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66634 5.00008C6.66634 4.53984 7.03944 4.16675 7.49967 4.16675H16.6663C17.1266 4.16675 17.4997 4.53984 17.4997 5.00008C17.4997 5.46032 17.1266 5.83341 16.6663 5.83341H7.49967C7.03944 5.83341 6.66634 5.46032 6.66634 5.00008Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66634 10.0001C6.66634 9.53984 7.03944 9.16675 7.49967 9.16675H16.6663C17.1266 9.16675 17.4997 9.53984 17.4997 10.0001C17.4997 10.4603 17.1266 10.8334 16.6663 10.8334H7.49967C7.03944 10.8334 6.66634 10.4603 6.66634 10.0001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66634 15.0001C6.66634 14.5398 7.03944 14.1667 7.49967 14.1667H16.6663C17.1266 14.1667 17.4997 14.5398 17.4997 15.0001C17.4997 15.4603 17.1266 15.8334 16.6663 15.8334H7.49967C7.03944 15.8334 6.66634 15.4603 6.66634 15.0001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16634 4.16675C4.62658 4.16675 4.99967 4.53984 4.99967 5.00008V5.00841C4.99967 5.46865 4.62658 5.84175 4.16634 5.84175C3.7061 5.84175 3.33301 5.46865 3.33301 5.00841V5.00008C3.33301 4.53984 3.7061 4.16675 4.16634 4.16675Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16634 9.16675C4.62658 9.16675 4.99967 9.53984 4.99967 10.0001V10.0084C4.99967 10.4687 4.62658 10.8417 4.16634 10.8417C3.7061 10.8417 3.33301 10.4687 3.33301 10.0084V10.0001C3.33301 9.53984 3.7061 9.16675 4.16634 9.16675Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16634 14.1667C4.62658 14.1667 4.99967 14.5398 4.99967 15.0001V15.0084C4.99967 15.4687 4.62658 15.8417 4.16634 15.8417C3.7061 15.8417 3.33301 15.4687 3.33301 15.0084V15.0001C3.33301 14.5398 3.7061 14.1667 4.16634 14.1667Z"
      fill="currentColor"
    />
  </svg>
);
